import Wrapper from "../../../layout/Wrapper";
import AccountServiceComponent from "../../../screens/callcenters/accounts";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Account Service",
	description: "",
};

export default function AccountService() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<AccountServiceComponent />
		</Wrapper>
	);
}